export default __webpack_public_path__ + "static/media/PUNK.5a409539.png";